import Image from 'next/image';
import styled, { css } from 'styled-components';

import { ArticleDescription, ArticleHeader } from '@components/atoms';
import { device } from '@styles/mediaQuery';
import useDevice from '@hooks/useDevice';

type ServiceProps = {
  title: string;
  description: string;
  image: string;
};

function ServiceCard({ title, image, description }: ServiceProps) {
  const { isMobile } = useDevice();

  return (
    <Wrapper>
      <DescriptionWrapper>
        <ArticleHeader
          titleMaxWidth="100%"
          title={title}
          align="left"
          fontSizeL="24px"
          fontSizeM="18px"
          fontSize="14px"
          lineHeightM="20px"
          lineHeightL="25px"
          lineHeight="18px"
        />
        {!isMobile && (
          <ArticleDescription
            description={description}
            align="left"
            margin="5px 0 10px"
            fontSizeL="16px"
          />
        )}
      </DescriptionWrapper>

      <ImageWrapper>
        <Image
          alt={image}
          src={image}
          loading="lazy"
          sizes="100wv"
          width={340}
          height={150}
          style={{ width: '100%', height: 'auto', objectFit: 'cover' }}
        />
      </ImageWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  min-width: 100%;
  max-width: 100%;

  border-radius: 12px;
  padding: 20px 20px;
  gap: 12px;

  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;

  background-color: ${({ theme }) => theme.colors.cardBackground};
  border: 1px solid ${({ theme }) => theme.colors.cardBorder};

  ${device.mobileL(css`
    min-width: 100%;
    max-width: 100%;
  `)}

  ${device.tablet(css`
    min-width: 48%;
    max-width: 48%;
    padding: 30px 30px;
  `)}

  ${device.laptopS(css`
    min-width: 30%;
  `)}
`;

const DescriptionWrapper = styled.div`
  width: 100%;
  flex: 1;
  height: 20%;
  display: flex;
  flex-direction: column;

  ${device.tablet(css`
    height: 40%;
  `)}
`;

const ImageWrapper = styled.div`
  width: 100%;
  display: flex;
  height: 80%;
  position: relative;
  overflow: hidden;
  border-radius: 8px;

  ${device.tablet(css`
    border-radius: 12px;
    max-height: 150px;
    height: 60%;
  `)}
`;

export default ServiceCard;
